import get from 'lodash.get';

export const navigateInVoicemailDrop = (route) => {
  if (route) {
    app.navigate(`voicemailrecording/${route}`);
  } else {
    app.navigate('voicemailrecording');
  }
}

export const isValid = (data, voicemails, record = true) => {
  const takenNames = voicemails.recordings.map(recording => { return recording.name });
  const friendlyname = get(data, 'friendlyname', '');
  const name = `${friendlyname.replace(/[^a-zA-Z0-9-_]/g, '')}.wav`

  if (record) {
    if (friendlyname === '') {
      return {
        title: 'Error!',
        message: 'You must enter a title for your recording.',
      };
    } else if (friendlyname.toLowerCase() === 'new' || takenNames.includes(name)) {
      return {
        title: 'Error!',
        message: 'Invalid title entered.',
      };
    }
  }

  // Feature code is optional (e.g. when using WebPhone/ClicktoCall+ only). When provided, must be 1-9 and unique.
  const featureCode = data.feature_code;
  const hasFeatureCode = featureCode !== '' && featureCode !== undefined && featureCode !== null && String(featureCode).trim() !== '';
  if (hasFeatureCode) {
    const num = parseInt(featureCode, 10);
    if (Number.isNaN(num) || num < 1 || num > 9) {
      return {
        title: 'Error!',
        message: 'You must enter a number between 1-9 as feature code.',
      };
    }
    for (const recording of voicemails.recordings) {
      if (String(recording.feature_code) === String(featureCode) && data.id !== recording.id) {
        return {
          title: 'Error!',
          message: 'You must enter a unique number as feature code.',
        };
      }
    }
  }

  const countdownRegExp = /^\d+$/;
  if (data.countdown != null && data.countdown !== '' && !countdownRegExp.test(String(data.countdown))) {
    return {
      title: 'Error!',
      message: 'Countdown must be a number.',
    };
  }

  if (data.countdown_enabled == '1' && data.countdown <= 2) {
    return {
      title: 'Error!',
      message: 'Countdown must be greater than 2 seconds.',
    };
  }
  return false;
}